<template>
    <button v-if="checkClipboardSupport"
            ref="copyButton"
            class="small copyTrigger"
            title="Copy to Clipboard">
        Copy
        <span class="tooltip">
            {{ clipboard.tooltipMessage }}
        </span>
    </button>
</template>

<script>
    import * as ClipboardJS from "clipboard";
    import { TweenMax }     from "gsap";

    export default {
    data() {
        return {
            clipboard: {
                trigger: null,
                tooltipMessage: null,
            },
            clipboardIsSupported: true,
        }
    },

    methods: {
        setCopyTrigger() {
            this.clipboard.trigger = new ClipboardJS(this.$refs.copyButton);
            this.setCopyTooltip();
        },

        setCopyTooltip() {
            TweenMax.set(".tooltip", {
                scale: 0,
                y: -20,
                autoAlpha: 0,
            });
        },

        setClipboardEvents() {
            let vm = this;
            this.clipboard.trigger.on('success', function(e) {
                let theTrigger = e.trigger;
                let tooltip = theTrigger.children;

                vm.clipboard.tooltipMessage = "Copied";
    
                vm.animateClipboardTooltip(tooltip);
                e.clearSelection();
            });

            this.clipboard.trigger.on('error', function(e) {
                let theTrigger = e.trigger;
                let tooltip = theTrigger.children;

                vm.clipboard.tooltipMessage = "Press Ctrl + C";

                TweenMax.set(tooltip, {
                    width: "132px",
                });

                this.animateClipboardTooltip(tooltip);
            });
        },

        animateClipboardTooltip(tooltip) {
            TweenMax.fromTo(tooltip, 0.25, {
                scale: 0,
                y: -20,
                autoAlpha: 0,
                ease: Power4.ease,
            }, {
                scale: 1,
                y: 0,
                autoAlpha: 1,
                ease: Power4.ease,
                onComplete: this.animateResetClipboardTooltip(),
            });
        },

        animateResetClipboardTooltip() {
            setTimeout(function() {
                TweenMax.to(".tooltip" , 0.25, {
                    scale: 0,
                    y: -20,
                    autoAlpha: 0,
                    ease: Power4.ease,
                });
            }, 3000);
        },

        checkClipboardSupport() {
            if(ClipboardJS.isSupported()) {
                this.clipboardIsSupported = true;
            } else {
                this.clipboardIsSupported = false;
            }
        },
    },

    mounted() {
        this.setCopyTrigger();
        this.setClipboardEvents();
    },

    destroyed() {
        this.clipboard.trigger.destroy();
    },
}
</script>
